/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { DateTimeWithTimezoneModel } from '@irian-ro/date-utils';
import { PackageResumeModel } from '@well/delivery-libs/packages/domain';
import { AddressVoModel } from '@well/domain';
import { NamedLocationVo } from '@well/named-location-management/domain';

export class ShipmentShortVoModel extends JSONable {
  uuid: string | null = null;

  owner: string | null = null;

  pickupAddress: AddressVoModel | null = null;

  pickupNamedLocationVO : NamedLocationVo | null = null;

  pickupCompanyName: string | null = null;

  deliveryAddress: AddressVoModel | null = null;

  deliveryNamedLocationVO : NamedLocationVo | null = null;

  deliveryCompanyName: string | null = null;

  pickupIntervalStart: DateTimeWithTimezoneModel | null = null;

  pickupIntervalEnd: DateTimeWithTimezoneModel | null = null;

  deliveryIntervalStart: DateTimeWithTimezoneModel | null = null;

  deliveryIntervalEnd: DateTimeWithTimezoneModel | null = null;

  packageResume: PackageResumeModel | null = null;

  externalReference: string | null = null;

  shipmentBaseUuid: string | null = null;

  completeShipmentBaseUuid: string | null = null;

  canEditDriverAndVehicle = true;
}
